import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-signature',
    templateUrl: './signature.component.html',
    styleUrls: ['./signature.component.scss'],
    standalone: false
})
export class SignatureComponent implements OnInit {

  public customIconLocation: string = null;

  public disablePoweredBy = false;

  constructor() {
    const parsedUrl = new URL(window.location.href);
    if (parsedUrl && (parsedUrl.hostname == 'dev-chariot.smartdinenow.com' || parsedUrl.hostname == 'chariot.smartdinenow.com')) {
      this.customIconLocation = 'assets/img/chariotLogo.png'
    }
  }

  ngOnInit() {}

}
